import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            borderRadius: 0,
            border: '1px solid #0A0A0A',
            background: '#FFFFFF',
            color: '#0A0A0A',
            fontFamily: 'Satoshi, sans-serif',
          },
        }}
      />
    </div>
  );
}

export default App;
